import { defineStore } from 'pinia';
import _ from "lodash"
import providers from '../service/providers';
import utils from '../service/utils';
const providerStore = defineStore('provider', {
  // arrow function recommended for full type inference
  state: () => {
    return {
      providers: [],
      sortAscending: false,
      selectedProvider: {},
      page: 1,
      numberOfPages: 0,
      loading: false
    }
  },
  actions: {
    sortProviders(key) {
      this.sortAscending = !this.sortAscending
      let clone = [...this.providers]

      if (key === "name" || key === "contact" || key === "location" || key === "email") {
        clone.sort(utils.alphabeticSorting(key, this.sortAscending));
      } else if (key === "phone") {
        clone.sort(utils.numericalSorting(key, this.sortAscending));
      }
      this.providers = clone;
    },
    async getNames(){
      try{
        const res = await providers.getNames();
        return res.result;
      } catch (e){
        console.log(e);
      }

    },
    async getAllProviders() {
      try {
        const res = await providers.getAllProviders();
        this.providers = res.providers;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async getProviders(q, f) {
      try{
        this.loading = true;
        this.providers = []
        let filter;
        if (f){
          filter = Object.values(f).join(',')
        }
        const res = await providers.getProviders(this.page, q, filter);
        this.providers = res.providers;
        this.numberOfPages = res.numberOfPages;
        this.loading = false;
        return res.providers
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    goToNextPage(){
      this.page = this.page + 1;
      this.getProviders();
    },
    goToPreviousPage(){
      if (this.page){
        this.page = this.page - 1;
        this.getProviders();
      }
    },
    async getProvidersById(id) {
      try {
        const res = await providers.getProvidersById(id);
        this.selectedProvider = res.result;
        const provider = res.result;
        return provider
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async createProvider(provider) {
      try {
        const res = await providers.createProvider(provider);
        this.providers = [...this.providers, res.result];
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async removeProvider(id) {
      try {
        const res = await providers.removeProvider(id);
        this.providers = this.providers.filter((u) => u._id !== id);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async updateProvider(id, provider) {
      try {
        await providers.updateProvider(id, provider);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  }
})

export default providerStore;



